import { EEventPostType } from '@configs'
import { Fragment } from 'react'
import {
  Control,
  FieldErrors,
  UseFormGetValues,
  UseFormSetValue,
  UseFormClearErrors,
  UseFormSetError,
} from 'react-hook-form'
import { ICreateEventPostValue } from 'src/interfaces/event-posts'
import ContentTab from 'src/pages/blog/content/ContentTab'
import EventRecapContent from './EventRecapContent'

interface IEventContentTabProps {
  activeTab: string
  control: Control<ICreateEventPostValue>
  setValue: UseFormSetValue<ICreateEventPostValue>
  clearErrors: UseFormClearErrors<ICreateEventPostValue>
  setError: UseFormSetError<ICreateEventPostValue>
  errors: FieldErrors<ICreateEventPostValue>
  getValues: UseFormGetValues<ICreateEventPostValue>
  contentName: string
  eventId?: string
  eventType: string
  eventImages?: any[]
  setEventImages?: React.Dispatch<React.SetStateAction<any[]>>
  onClickSelectThumbnail?: () => void
  isModalLoading?: boolean
}

const EventContentTab: React.FC<IEventContentTabProps> = ({
  activeTab,
  control,
  setValue,
  clearErrors,
  setError,
  errors,
  getValues,
  contentName,
  eventId,
  eventType,
  eventImages,
  setEventImages,
  onClickSelectThumbnail,
  isModalLoading,
}) => {
  return (
    <Fragment>
      {eventType === EEventPostType.EVENT_POST_RECAP ? (
        <EventRecapContent
          activeTab={activeTab}
          control={control}
          setValue={setValue}
          clearErrors={clearErrors}
          setError={setError}
          errors={errors}
          getValues={getValues}
          contentName={contentName}
          eventId={eventId}
          eventImages={eventImages}
          setEventImages={setEventImages}
          onClickSelectThumbnail={onClickSelectThumbnail}
          isModalLoading={isModalLoading}
        />
      ) : (
        <ContentTab
          activeTab={activeTab}
          control={control}
          setValue={setValue}
          clearErrors={clearErrors}
          setError={setError}
          errors={errors}
          getValues={getValues}
          contentName={contentName}
        />
      )}
    </Fragment>
  )
}

export default EventContentTab
